import { Component, OnInit, ChangeDetectorRef, QueryList, ElementRef, ViewChildren, ViewChild } from '@angular/core';
import { AspNetUsersAction, BaseDataService, LoaderService, QueryParameter, Action, AspNetRolesAction, ModelData, ModalSize, ModalService, BaseModalContainer, ModalContainerService, UserService, NotificationService, CryptoService } from 'yt-ng-framework';
import { UserView } from '../user/user-view';
import { FormBuilder, FormGroup } from '@angular/forms';
import { List } from 'immutable';
// import { NotificationsService } from 'angular2-notifications';
import { ActivatedRoute } from '@angular/router';
import { DodajRolaActionComponent } from './dodaj-rola-action/dodaj-rola-action.component';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-podesavanje-akcija',
  templateUrl: './podesavanje-akcija.component.html',
  styleUrls: ['./podesavanje-akcija.component.scss']
})
export class PodesavanjeAkcijaComponent extends BaseModalContainer<Action> implements  OnInit{

  constructor(
    protected baseDataService: BaseDataService,
    protected changeDetectorRef: ChangeDetectorRef,
    private fb: FormBuilder,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected loaderService: LoaderService,
    protected modalService: ModalService,
    protected modalContainerService: ModalContainerService<Action>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  resultUser: any;
  resultRole: any;
  resultAction: any;
  resultOrgJed = new Array();
  formGroupUser = new FormGroup({});
  formGroupRole = new FormGroup({});
  formGroupAction = new FormGroup({});
  parameterListUser: List<QueryParameter> = List([]);
  userID: QueryParameter = new QueryParameter();
  @ViewChildren('vrednostKorisnikCheckbox') checkboxes: QueryList<ElementRef>;

  ngOnInit() {
    this.formGroupUser = this.fb.group({
      UserID: [''],
      RoleID: [''],
      OrgJedID: [''],
      FirmaID: [''],
      resultUser: this.fb.array([])  // Kreiramo FormArray
    });

    this.formGroupRole = this.fb.group({
      RoleID: [''],
      resultRole: this.fb.array([])  // Kreiramo FormArray
    });

    this.formGroupAction = this.fb.group({
      resultAction: this.fb.array([])  // Kreiramo FormArray
    });

    this.userID.Value = 1; //this.Item.ID;
    this.userID.Name = "userID";
    this.parameterListUser = this.parameterListUser.push(this.userID);

    let user = CryptoService.Decrypt(sessionStorage.getItem('sel-user'))
    let parameter = new QueryParameter('username', user.Username);

    this.baseDataService.Get('User', 'GetByUsername', [parameter], UserView)
      .subscribe((data: any) => {
        let userID = data.ID;
        let roleID = data.RoleID;

        this.userID.Value = data.ID; //this.Item.ID;
        this.userID.Name = "userID";
        this.parameterListUser = this.parameterListUser.push(this.userID);

        this.formGroupUser.patchValue({ UserID: userID });
        this.formGroupUser.patchValue({ RoleID: roleID });
        this.formGroupRole.patchValue({RoleID: roleID});
        this.GetDataUserAction(userID, roleID);
        this.GetDataRoleAction(roleID);
        this.GetDataAction();
        
        //this.GetDataOrgJed(userID);
      });
  }

  GetDataUserAction(userID, roleID) {
    var parametersUser = [];
    

    var parameterUserId = new QueryParameter();
    var parameterRoleId = new QueryParameter();
  
    parameterUserId.Name = 'userID';
    parameterUserId.Value = userID;
    parametersUser.push(parameterUserId);

    parameterRoleId.Name = 'roleID';
    parameterRoleId.Value = roleID;
    parametersUser.push(parameterRoleId);

    this.loaderService.ShowLoader();
    this.baseDataService.GetData("Action", "GetByUserID", {'UserID': userID,'RoleID': roleID} )
      .subscribe(data => {
        
        this.resultUser = data;
        
        this.initializeUserFormArray(this.resultUser);
        
      },
      error => {
        // Obrada greške
      },
      () => {
        this.loaderService.HideLoader(); // Sakrivamo loader nakon što je učitavanje gotovo
      });
  }

  GetDataAction(){
    this.loaderService.ShowLoader();
    this.baseDataService.Get("Action", "GetAll", null, Action)
      .subscribe(data => {
        this.resultAction = data;
        this.initializeActionFormArray(this.resultAction);
      },
      error => {
        // Obrada greške
      },
      () => {
        this.loaderService.HideLoader(); // Sakrivamo loader nakon što je učitavanje gotovo
      })
  }

  GetDataRoleAction(roleID){
    var parametersRole = [];
    var parameterRoleId = new QueryParameter();

    parameterRoleId.Name = 'roleID';
    parameterRoleId.Value = roleID;
    parametersRole.push(parameterRoleId);

    this.loaderService.ShowLoader();
    this.baseDataService.GetData("Action", "GetByRoleID", {'RoleID': roleID})
      .subscribe(data=>{
        this.resultRole = data;
        this.initializeRoleFormArray(this.resultRole);
      },
      error => {
        // Obrada greške
      },
      () => {
        this.loaderService.HideLoader(); // Sakrivamo loader nakon što je učitavanje gotovo
      })
  }

  private initializeUserFormArray(data: any[]) {
    const formArray = this.fb.array([]);  // Kreiramo novi prazan FormArray

    data.forEach((item) => {
      formArray.push(this.fb.group({
        ID: [item.ID],
        Model: [item.Model],
        Naziv: [item.Naziv],
        VrednostRola: [item.VrednostRola],
        VrednostKorisnik: [item.VrednostKorisnik]
      }));
    });

    this.formGroupUser.setControl('resultUser', formArray);  // Zamenjujemo stari FormArray sa novim
  }

  private initializeRoleFormArray(data: any[]) {
    const formArray = this.fb.array([]);  // Kreiramo novi prazan FormArray

    data.forEach((item) => {
      formArray.push(this.fb.group({
        ID: [item.ID],
        Model: [item.Model],
        Naziv: [item.Naziv],
        VrednostRola: [item.VrednostRola]
      }));
    });

    this.formGroupRole.setControl('resultRole', formArray);  // Zamenjujemo stari FormArray sa novim
  }

  initializeActionFormArray(data: any[]){
    const formArray = this.fb.array([]);  // Kreiramo novi prazan FormArray

    data.forEach((item) => {
      formArray.push(this.fb.group({
        ID: [item.ID],
        Model: [item.Model],
        Naziv: [item.Name],
        DefaultValue: [item.DefaultValue],
        Description: [item.Description],
        SendToClient: [item.SendToClient]
      }));
    });

    this.formGroupAction.setControl('resultAction', formArray);  // Zamenjujemo stari FormArray sa novim    
  }

  OnUserSelected(item) {
    this.parameterListUser = List([]);
    this.userID.Value = item.ID; //this.Item.ID;
    this.userID.Name = "userID";
    this.parameterListUser = this.parameterListUser.push(this.userID);
  }


  onVrednostUserChange(vrednost: boolean, actionID: number, index: number) {
    let orgJedID = this.formGroupUser.get('OrgJedID').value;
    let companyID = this.formGroupUser.get('FirmaID').value;

    if (!orgJedID || !companyID) {
      alert('Potrebno je odabrati organizacionu jedinicu i firmu za uspešan unos!');
      // Vraćanje vrednosti checkbox-a nazad na prethodno stanje
      this.checkboxes.toArray()[index].nativeElement.checked = !vrednost;
      return;
    }else{
      let parameters = { UserID: this.formGroupUser.get('UserID').value, ActionID: actionID, value: vrednost, OrgJedID: orgJedID, CompanyID: companyID };
      this.baseDataService.Post('Action', 'AspNetUsersActionSave', parameters, AspNetUsersAction)
        .subscribe(data => {
          // this.notificationService.success('Uspeh!', 'Uspešno izmenjena vrednost akcije!')
          this.toastrService.success('Uspeh!', 'Uspešno izmenjena vrednost akcije!');
        });
    }
  }

  onVrednostRoleChange(vrednost: boolean, actionID: number){
    let parameters = { ActionID: actionID, value: vrednost, RoleID: this.formGroupRole.get('RoleID').value };
    this.baseDataService.Post('Action', 'AspNetRolesActionSave', parameters, AspNetRolesAction)
      .subscribe(data => {
        // this.notificationService.success('Uspeh!', 'Uspešno izmenjena vrednost akcije!')
        this.toastrService.success('Uspeh!', 'Uspešno izmenjena vrednost akcije!');
      });
  }

  onVrednostActionChange(vrednost: boolean, actionForm: any){
    let actionID = actionForm.get('ID').value;
    let model = actionForm.get('Model').value;
    let name = actionForm.get('Naziv').value;
    let description = actionForm.get('Description').value;
    let sendToClient = actionForm.get('SendToClient').value;

    let parameters = { ID: actionID, DefaultValue: vrednost, Model: model, Name: name, Description: description, SendToClient: sendToClient };
    this.baseDataService.Post('Action', 'save', parameters, Action)
      .subscribe(data => {
        // this.notificationService.success('Uspeh!', 'Uspešno izmenjena vrednost akcije!')
        this.toastrService.success('Uspeh!', 'Uspešno izmenjena vrednost akcije!');
      });
  }

  OnAddActionRole(){
    let modelData = new ModelData(null);
    modelData.ModalSize = ModalSize.Lg;
    modelData.UpdateComponent = DodajRolaActionComponent;
    

    let roleId: number = this.formGroupRole.get('RoleID').value;
    let roleIdParameter = new QueryParameter('RoleID', roleId);



    if(modelData){
      this.modalService.ShowModal(0, modelData, null, true, [
        roleIdParameter
      ])
      .result.then( result => {
        this.GetDataRoleAction(this.formGroupRole.get('RoleID').value)
      },
      () =>{})
    }
  }
}
